const { PODCAST_CATEGORIES } = require('./const')

const mapCategoriestoSlugs = (categories) => {
  if (categories.length === 0) return ''

  const categoryNames = categories.map((category) => category.name)
  if (categoryNames.includes('News')) return 'news'
  if (categoryNames.includes('Voices')) return 'voices'
  if (categoryNames.includes('Partners')) return 'partners'
  if (categoryNames.includes('Circle of Chairs')) return 'circle-of-chairs'
  if (categoryNames.some((category) => PODCAST_CATEGORIES.includes(category)))
    return 'podcasts'

  return 'resources'
}

module.exports = {
  mapCategoriestoSlugs
}
